if (!customElements.get('multi-collection-grid')) {
  customElements.define('multi-collection-grid', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.categoryToggles = [...this.querySelectorAll('[data-group-toggle]')];
      this.availabilityToggles = [...this.querySelectorAll('[data-availability-toggle]')];
      this.groups = [...this.querySelectorAll('[data-collection-group]')];
      const filters = this.querySelector('[data-group-filters]');
      if (!filters) return;
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (event.target.matches('[data-group-toggle], [data-availability-toggle]')) this.updateGroups();
      }, options);
      this.querySelector('[data-group-reset]').addEventListener('click', () => {
        [...this.categoryToggles, ...this.availabilityToggles].forEach(toggle => { toggle.checked = false; });
        this.updateGroups();
      }, options);
      filters.hidden = false;
      this.updateGroups();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    updateGroups() {
      const selectedCategories = new Set(this.categoryToggles.filter(toggle => toggle.checked).map(toggle => toggle.value));
      const selectedAvailability = new Set(this.availabilityToggles.filter(toggle => toggle.checked).map(toggle => toggle.value));
      let visibleGroups = 0;
      let visibleProducts = 0;
      this.groups.forEach(group => {
        const categoryMatches = selectedCategories.size === 0 || selectedCategories.has(group.dataset.collectionGroup);
        let groupVisibleProducts = 0;
        group.querySelectorAll('[data-multi-product]').forEach(product => {
          const availabilityMatches = selectedAvailability.size === 0 || selectedAvailability.has(product.dataset.productAvailability);
          product.hidden = !categoryMatches || !availabilityMatches;
          if (!product.hidden) {
            groupVisibleProducts += 1;
            visibleProducts += 1;
          }
        });
        group.hidden = !categoryMatches || groupVisibleProducts === 0;
        if (!group.hidden) visibleGroups += 1;
        const viewAll = group.querySelector('[data-group-view-all]');
        if (viewAll) viewAll.hidden = selectedAvailability.size > 0;
      });
      const noResults = this.querySelector('[data-filter-no-results]');
      if (noResults) noResults.hidden = visibleProducts > 0;
      const status = this.querySelector('[data-group-status]');
      if (status) status.textContent = this.dataset.statusTemplate
        .replace('[visible]', String(visibleGroups)).replace('[total]', String(this.groups.length));
    }
  });
}
